import { useCallback } from 'react';

import { usePageState } from '../../PageState/PageStateProvider';

export const useSharedSubsidiaryDrill = (rcid: number) => {
  const { pageState, dispatch } = usePageState();
  const shared = pageState.subsidiaryDrill;
  const current = shared?.rcid === rcid ? shared : undefined;
  const share = useCallback(
    (next: number[], color: string | undefined) =>
      dispatch({
        type: 'SET_SUBSIDIARY_DRILL',
        payload: { rcid, path: next, ...(color !== undefined && { color }) },
      }),
    [dispatch, rcid]
  );
  return { path: current?.path, color: current?.color, share };
};
